(() => {
  const previousValues = new Map();
  let scheduledFrame;

  const animateProgressBars = () => {
    cancelAnimationFrame(scheduledFrame);
    scheduledFrame = requestAnimationFrame(() => {
      document.querySelectorAll('[data-promotion-progress-bar]').forEach((bar) => {
        const key = bar.dataset.promotionProgressBar;
        const target = Math.min(Math.max(Number(bar.dataset.progressValue) || 0, 0), 100);
        const previous = previousValues.has(key) ? previousValues.get(key) : 0;

        if (previous !== target) {
          bar.style.width = `${previous}%`;
          requestAnimationFrame(() => {
            bar.style.width = `${target}%`;
          });
        } else {
          bar.style.width = `${target}%`;
        }

        previousValues.set(key, target);
      });
    });
  };

  const cartDrawer = document.querySelector('#CartDrawer');

  if (cartDrawer) {
    new MutationObserver(animateProgressBars).observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }

  animateProgressBars();
})();
